import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../../state/Store";
import MessageDetail from "../../types/system/MessageDetail";
import { openMessage } from "../../state/system/Messaging";

interface MessagingSummaryProps {
    messages: Array<MessageDetail>;
    openedMessage?: MessageDetail;
    openMessage: (message: MessageDetail) => void;
}

class MessagingSummary extends React.Component<MessagingSummaryProps> {
    render(): React.ReactNode {
        return (
            <>
                {this.props.messages
                    .map((message, index) => (
                        <span key={index}>
                            <button
                                className={`message${
                                    this.props.openedMessage?.Message?.Id === message?.Message?.Id ? " open" : ""
                                }`}
                                onClick={() => this.props.openMessage(message)}>
                                <span
                                    className="sender"
                                    data-tip={message.SenderDetails}>
                                    {message.SenderDetails}
                                </span>
                                <span className="message">
                                    {message.BareMessage}
                                </span>
                            </button>
                        </span>
                    ))}
                {this.props.messages.length === 0 && (
                    <span className="no-messages">No messages</span>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { messaging } = state.db;
    return {
        messages: messaging.summary,
        openedMessage: messaging.openedMessage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        openMessage: (message: MessageDetail) => dispatch(openMessage(message)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagingSummary);
